import { Component } from '@angular/core';
import { PillarPagesTemp } from "../../components/pillar-pages-temp/pillar-pages-temp";

@Component({
  selector: 'app-individualized-advising',
  imports: [PillarPagesTemp],
  templateUrl: './individualized-advising.html',
  styleUrl: './individualized-advising.scss',
})
export class IndividualizedAdvising {

}
